import { z } from 'zod'

export const visitStatusSchema = z.enum([
  'ATTENDED',
  'ACTIVE',
  'LATE_CANCEL',
  'NO_SHOW',
  'CANCELLED',
])
export type VisitStatus = z.infer<typeof visitStatusSchema>

export const VisitStatus = {
  ATTENDED: 'ATTENDED',
  ACTIVE: 'ACTIVE',
  LATE_CANCEL: 'LATE_CANCEL',
  NO_SHOW: 'NO_SHOW',
  CANCELLED: 'CANCELLED',
} as const satisfies Record<string, VisitStatus>

export const visitSchema = z.object({
  id: z.string(),
  description: z.string(),
  bookedAt: z.string(),
  sessionDateTime: z.string(),
  creditsUsed: z.number(),
  creditsRefunded: z.number().optional(),
  status: visitStatusSchema,
  isBuddyBooking: z.boolean().optional(),
  // Site where this visit/credit consumption occurred. Compared against the service's
  // home site to flag visits taken at a shared (corporate-linked) location.
  siteId: z.string().optional(),
})
export type Visit = z.infer<typeof visitSchema>
